import { render, staticRenderFns } from "./WrestlingBracket.vue?vue&type=template&id=05b1b33c&scoped=true"
import script from "./WrestlingBracket.vue?vue&type=script&lang=js"
export * from "./WrestlingBracket.vue?vue&type=script&lang=js"
import style0 from "./WrestlingBracket.vue?vue&type=style&index=0&id=05b1b33c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b1b33c",
  null
  
)

export default component.exports